import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export const globalItemsSlice = createSlice({
  name: 'globalItemsStore',
  initialState: {
    openTransitionAlert: false,
  },
  reducers: {
    SET_OPEN_TRANSITION_ALERT: (state, action: PayloadAction<boolean>) => {
      state.openTransitionAlert = action.payload;
    },
  },
});

export default globalItemsSlice.reducer;
